import PropTypes from 'prop-types';

export const MoldRelease = {
  id: PropTypes.number,
  toolId: PropTypes.string,
  customerName: PropTypes.string,
  customerContact: PropTypes.string,
  customerEmail: PropTypes.string,
  customerPhone: PropTypes.string,
  moldNumber: PropTypes.string,
  moldDescription: PropTypes.string,
  partID: PropTypes.number,
   // partNumber: PropTypes.string,
  materialType: PropTypes.string,
  cavity: PropTypes.string,
  shipmentDate: PropTypes.string,
  recievedDate: PropTypes.string,
  carriier: PropTypes.string,
  trackingNumber: PropTypes.string,
  conditionOfShipment: PropTypes.string,
  inspectedBy: PropTypes.string,
  moldDrawing: PropTypes.string,
  moldSpecificationsDocument: PropTypes.string,
  previousMaintenanceRecords: PropTypes.string,
  moldPictureOnTheTrailer: PropTypes.string,
  moldPictureUploaded: PropTypes.string,
  moldPictureOpen: PropTypes.string,
  additionalPicture: PropTypes.object,
  noVisibleDamage: PropTypes.bool,
  noRustOrCorrosion: PropTypes.bool,
  properLabeling: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  length: PropTypes.string,
  functionalTest: PropTypes.bool,
  functionalTestPicture: PropTypes.string,
  additionalComments: PropTypes.string,
  unloadingApproval: PropTypes.string,
  qualityControlApprovedBy: PropTypes.string,
  engineeringApprovedBy: PropTypes.string,
  submittedBy: PropTypes.string,
};

// export const ShippingDocuments = {
//   id: PropTypes.number,
//   fileCategoryId: PropTypes.number,
//   fileCategory: PropTypes.string,
//   filePath: PropTypes.string,
//   fileName: PropTypes.string,
// };
